import {
    contentCreatingRoleEnum, contentCreatingRolePermissionEnum,
    trainingAndFieldRoleEnum,
    trainingAndFieldRolePermissionEnum,
    workspaceUsersEnum,
} from '../../../serverClientShared/sharedEnums';
import {generalStore} from '../../../index';
import React from 'react';

const getAdministrationRoleOptions = (isFilterMode) => {
    const options = [workspaceUsersEnum.USAGE_ANALYSIS];
    if (generalStore.isWorkspaceOwner) options.push(workspaceUsersEnum.WORKSPACE_ADMIN);
    if (isFilterMode) options.push(workspaceUsersEnum.WORKSPACE_OWNER);
    options.push(workspaceUsersEnum.NONE);
    return options;
};

const administrationRolePermissions = {
    [workspaceUsersEnum.NONE]: 'No administration permissions',
    [workspaceUsersEnum.USAGE_ANALYSIS]: 'Generates user activity reports',
    [workspaceUsersEnum.WORKSPACE_ADMIN]: 'Manages users and settings',
    [workspaceUsersEnum.WORKSPACE_OWNER]: 'Full control and ownership',
};

export const RenderOptionByType = ({type, position, setSelection, setIsOptionBoxOpen, selectedOptions, singleSelect, isFilterMode}) => {
    const getOptions = (type) => {
        switch (type) {
            case 'trainingAndField':
                return [Object.values(trainingAndFieldRoleEnum), Object.values(trainingAndFieldRolePermissionEnum)];
            case 'contentCreating':
                return [Object.values(contentCreatingRoleEnum), Object.values(contentCreatingRolePermissionEnum)];
            case 'administration': {
                const adminOptions = getAdministrationRoleOptions(isFilterMode);
                return [adminOptions, adminOptions.map((r) => administrationRolePermissions[r])];
            }
            default:
                return [[], []];
        }
    };
    const [optionList, detailedPermissionOptionList] = getOptions(type);

    return (
        <>
            <div
                data-testid="role-options-backdrop"
                className="fixed inset-0 z-[2999]"
                onClick={() => setIsOptionBoxOpen(false)}
            />
            <div className="absolute flex flex-col item-start p-4 bg-background-normal rounded-menu gap-1" style={{
                width: '332px',
                maxHeight: '40dvh',
                overflowY: 'auto',
                border: '2px solid var(--Panels-Panels-Normal, #D9E0F0)',
                boxShadow: '1px 1px 10px 0 rgba(0, 0, 0, 0.15)',
                top: `${position.y}px`,
                left: `${position.x}px`,
                zIndex: 3000,
                fontSize: '14px',
            }}>
                {optionList.map((option, index) => {
                    const isNoneOption = option === 'none';
                    const isNoneSelected = selectedOptions(type).has('none') && isNoneOption && selectedOptions(type).size === 1;
                    const showAsAll = isNoneSelected && !singleSelect && !isFilterMode;
                    const isSelected = isFilterMode
                        ? selectedOptions(type).has(option)
                        : selectedOptions(type).has(option) && !isNoneOption;
                    return (
                        <div key={index}
                             data-testid={`role-option-${option}`}
                             className={`flex p-1 flex-col items-start gap-1 w-full font-bold rounded-menu cursor-pointer hover:bg-panels-normal ${isSelected ? 'bg-nav-selected' : ''}`}
                             onClick={() => {
                                 setSelection(type, option);
                             }}
                        >
                            {showAsAll ? 'All' : option === trainingAndFieldRoleEnum.OPERATOR_3D ? 'Operator MR' : generalStore.translate(option)}
                            <div className="flex flex-col justify-center items-start font-normal cursor-pointer">
                                {showAsAll ? 'Select all roles' : detailedPermissionOptionList[index]}
                            </div>
                        </div>
                    );
                })}
            </div>
        </>
    );
};
